import Swiper from 'swiper/bundle';
import { hexToCSSFilter } from 'hex-to-css-filter';


export default () => {
    const heroSlider = document.querySelector('.hero');
    if (heroSlider) {
        new Swiper(heroSlider, {
            slidesPerView: 1,
            slidesPerGroup: 1,
            centeredSlides: true,
            spaceBetween: 0,
            autoplay: {
                delay: 3500,
            },
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
                type: 'bullets',
                bulletElement: 'div',
            },
            lazy: {
                loadPrevNext: true,
            },
            on: {
                init: (swiper) => {
                    const slide = swiper.slides[swiper.realIndex];
                    setCustonProperty(heroSlider, '--slider-accent-bg', slide.dataset.slideAccent);
                    let arrow = slide.querySelectorAll('a.arrow-button img');
                    let filter = hexToCSSFilter(slide.dataset.slideAccent).filter;
                    if (arrow) {
                        arrow.forEach(item => {
                            item.style.filter =  filter.replace(/;/g, '');
                            item.style.webkitFilter = filter.replace(/;/g, '');
                        })
                    }
                },
                realIndexChange: (swiper) => {
                    const slide = swiper.slides[swiper.realIndex];
                    setCustonProperty(heroSlider, '--slider-accent-bg', slide.dataset.slideAccent);
                    let arrow = slide.querySelectorAll('a.arrow-button img');
                    let filter = hexToCSSFilter(slide.dataset.slideAccent).filter;
                    if (arrow) {
                        arrow.forEach(item => {
                            item.style.filter = filter.replace(/;/g, '');
                            item.style.webkitFilter = filter.replace(/;/g, '');
                        })
                    }
                },
            },
        });
    }
}

const setCustonProperty = (element, property, value) => {
    element.style.setProperty(property, value);
}
